var _excluded = ["list", "size", "type"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Icon } from '../../../../foundations/Icon';
import { forwardRef } from '../../../../utils';
import { useMultiStyleConfig } from '../../../../utils/use-style-config';
import { Box } from '../../../internal';
import { _Paragraph } from '../_Paragraph';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * @private
 */
export var _ParagraphList = forwardRef((_ref, ref) => {
  var {
    list,
    size,
    type
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var isListWithIcons = list.every(paragraph => 'icon' in paragraph);
  var styles = useMultiStyleConfig('_ParagraphList', {
    size,
    icon: isListWithIcons,
    type
  });

  var bullet = /*#__PURE__*/_jsx(Box, {
    __css: styles['bulletWrapper'],
    children: /*#__PURE__*/_jsx(Box, {
      __css: styles['bullet']
    })
  });

  var isParagraphWithIcon = paragraph => !!paragraph && 'icon' in paragraph;

  var getUnorderedListItem = paragraph => isParagraphWithIcon(paragraph) ? paragraph.icon && /*#__PURE__*/_jsx(Icon, {
    type: paragraph.icon
    /* Is used for accessibility reasons to prevent an element from being read by a screen reader. */
    ,
    "aria-hidden": "true"
  }) : bullet;

  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    as: type === 'ordered' ? 'ol' : 'ul',
    ref: ref,
    "data-component": "_ParagraphList",
    "data-testid": "paragraph-list",
    __css: styles['container']
  }, props), {}, {
    children: list.map((paragraph, index) => /*#__PURE__*/_jsxs(Box, {
      as: "li",
      __css: styles['listItem'],
      children: [type === 'unordered' ? getUnorderedListItem(paragraph) : /*#__PURE__*/_jsxs(Box, {
        __css: styles['number'],
        children: [index + 1, "."]
      }), /*#__PURE__*/_jsx(_Paragraph, _objectSpread(_objectSpread({}, paragraph), {}, {
        size: size
      }))]
    }, index + 1))
  }));
});
_ParagraphList.displayName = '_ParagraphList';
//# sourceMappingURL=_ParagraphList.js.map